import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Container } from "reactstrap";

interface Props {
  maintenanceMode: {
    Title: string;
    Description: string;
    Status: boolean;
  };
}

const Maintenance = ({ maintenanceMode }: Props) => {
  let navigate = useNavigate();

  return (
    <Container fluid>
      <div
        className="d-flex flex-column justify-content-center align-items-center"
        style={{ width: "100%", height: "100vh" }}
      >
        <img
          src="/img/maintenance.png"
          alt="Maintenance"
          style={{ maxWidth: "100vw" }}
        />
        <span
          className="font-weight-bold text-center"
          style={{ fontSize: "26px" }}
        >
          {maintenanceMode.Title ?? "Sorry! We are Doing Some Maintenance"}
        </span>
        <p
          className="mt-2 text-center w-100"
          style={{
            maxWidth: 600,
            fontSize: "17px",
          }}
        >
          {maintenanceMode.Description ??
            "Our Platform is Under Maintenance. We're tending to the digital soil, please bear with us as we cultivate excellence. Thank you for your understanding."}
        </p>
        <div
          className="d-flex justify-content-center align-items-center py-6 flex-wrap"
          style={{ gap: "20px" }}
        >
          <Button color="secondary" onClick={() => navigate("/clouds")}>
            Go Back
          </Button>
          <Button
            color="primary"
            onClick={() => {
              window.open("mailto:support@growthcloud.com");
            }}
          >
            Contact Support
          </Button>
        </div>
      </div>
    </Container>
  );
};

export default Maintenance;
